/**
 * Thing puzzles — common nouns, household items, foods, classic Americana
 * objects. Era-appropriate (no smartphones, no apps, no recent tech).
 */
export const THINGS = [
  'ROCKING CHAIR ON THE PORCH',
  'FRESHLY BAKED APPLE PIE',
  'OLD FAMILY PHOTO ALBUM',
  'WARM BREAD FROM THE OVEN',
  'GRANDMOTHERS QUILT',
  'A COZY FIREPLACE',
  'A CUP OF MORNING COFFEE',
  'SUNDAY DINNER WITH FAMILY',
  'A BUNCH OF FRESH FLOWERS',
  'A LONG WALK IN THE PARK',
  'A LETTER FROM A FRIEND',
  'THE FAMILY CHRISTMAS TREE',
  'A WARM WOOL SWEATER',
  'GRANDFATHER CLOCK',
  'OLD UPRIGHT PIANO',
  'GARDEN VEGETABLES',
  'HOMEMADE LEMONADE',
  'A POT OF CHICKEN SOUP',
  'BUTTERMILK BISCUITS',
  'A WICKER PICNIC BASKET',
  'CHECKERED TABLECLOTH',
  'GOLDEN AUTUMN LEAVES',
  'FIRST SNOW OF WINTER',
  'CHERRY BLOSSOM TREES',
  'A LIGHTHOUSE BY THE SEA',
  'A FRESHLY WASHED CAR',
  'NEW PAIR OF READING GLASSES',
  'A WELL WORN PAPERBACK',
  'A LEATHER BOUND BIBLE',
  'A HAND CARVED WALKING STICK',
  'AN ANTIQUE POCKET WATCH',
  'A WOOD BURNING STOVE',
  'A SCREEN DOOR SLAMMING',
  'FRESH LAUNDRY ON THE LINE',
  'A WHISTLING TEAKETTLE',
  'CHINA TEA SET',
  'SILVER CANDLESTICKS',
  'A PORCELAIN VASE',
  'A SET OF SILVER COINS',
  'A POSTCARD FROM PARIS',
  'A TICKET TO THE THEATER',
  'A NEW WINTER COAT',
  'A FELT FEDORA HAT',
  'A PAIR OF DRESS GLOVES',
  'A POLISHED SILVER SPOON',
  'THE WEEKEND NEWSPAPER',
  'THE EVENING NEWS HOUR',
  'A GAME OF CARDS',
  'A JIGSAW PUZZLE',
  'A BOX OF CHOCOLATES',
  'A BOUQUET OF ROSES',
  'A WICKER ROCKING CHAIR',
  'WIND CHIMES ON THE PORCH',
  'A HUMMINGBIRD FEEDER',
  'A WELL TENDED GARDEN',
  'A BACKYARD CLOTHESLINE',
  'A SUNDAY ROAST',
  'PEANUT BUTTER AND JELLY',
  'A TALL GLASS OF MILK',
  'OATMEAL WITH BROWN SUGAR',
  'A BOWL OF VANILLA ICE CREAM',
  'STRAWBERRY SHORTCAKE',
  'A SLICE OF POUND CAKE',
  'CHOCOLATE CHIP COOKIES',
  'FRESH FROM THE FARM EGGS',
  'A CHRISTMAS WREATH',
  'A LETTER TO SANTA',
  'A POT OF HOT CHOCOLATE',
  'A CRACKLING BONFIRE',
  'A SUMMER LEMONADE STAND',
  'A FAMILY ROAD TRIP',
  'A GENTLE SPRING RAIN',
  'A FRONT PORCH SWING',
  'A WHISPERING WILLOW TREE',
  'A POCKET FULL OF MINTS',
  'A NEW HARDCOVER NOVEL',
  'A POLISHED PAIR OF SHOES',
] as const;
